<template>
    <div id="planning_kecamatan" >

<section class="content">
<div class="container-fluid">

    <div class="row clearfix">

        <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
                <div class="col-md-3 searching">
                    <span class="h_page">Data Desa/Keelurahan</span> <br> <br>
                </div>
                <div class="col-md-6">

                </div>
                <div class="col-md-3 searching">
                    <div class="input-group">
                        <span class="input-group-btn">
                            <button @click="getDataKabupaten()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                        </span>
                        <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                    </div> <br>
                </div>
            </div>
        </div>


        <div class="col-xs-12 card">
    <!-- ============================================================ MULAI ======================================================================== -->
            <br>
            <div class="table-responsive">
                <table class="table table-bordered" style="width: 100%">
                    <thead>
                    <tr class="bg-info">
                        <th style="width: 5%" class="text-center">No.</th>
                        <th style="width: 10%" class="text-center">Kode <br> Provinsi</th>
                        <th style="width: 10%" class="text-center">Kode Kabupaten</th>
                        <th style="width: 10%" class="text-center">Kode Kecamatan</th>
                        <th style="width: 10%" class="text-center">Kode Desa/Kelurahan</th>
                        <th style="width: 25%" class="text-center">Nama Desa/Kelurahan</th>
                        <th style="width: 15%" class="text-center">Nama Kecamatan</th>
                        <th style="width: 15%" class="text-center">Pilihan</th>
                    </tr>
                    </thead>
                    <tbody>
                        <!-- track-by="data.createdtime" -->
                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.des_kel_id">
                            <td>{{index+1}}</td>
                            <td>{{data.kode_provinsi}}</td>
                            <td>{{data.kode_kabupaten}}</td>
                            <td>{{data.kode_kecamatan}}</td>
                            <td>{{data.kode_des_kel}}</td>
                            <td>{{data.nama_des_kel}}</td>
                            <td>{{data.nama_kecamatan}}</td>

                            <td class="text-center" >
                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                    &nbsp;
                                <button @click="removeData(data.des_kel_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <hr>
                <div class="text-center">
                    <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                        <i class="material-icons">skip_previous</i>
                    </button>
                    &nbsp;
                    <span style="font-size: 85%; color: #a5a5a5">
                        <b>{{page_first}} - {{page_last}}</b>
                    </span>
                    &nbsp;
                    <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                        <i class="material-icons">skip_next</i>
                    </button>
                </div>
            <hr>

            <!-- ============================================================ MODAL ======================================================================== -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-blue">
                                <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                            </div>
                        <form @submit.prevent="addData()">

                        <div class="modal-body">
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Kabupaten</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <select @change="getDataKecamatan()" v-model="data.kabupaten_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                <option value="" :disabled="true">-- Pilih Kabupaten --</option>
                                                <option v-for="(data) in list_kabupaten" :key="data.kabupaten_id" v-bind:value="data.kabupaten_id">[{{data.kode_kabupaten}}] {{data.nama_kabupaten}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Kecamatan</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <select v-model="data.kecamatan_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                <option value="" :disabled="true">-- Pilih Kecamatan --</option>
                                                <option v-for="(data) in list_kecamatan" :key="data.kecamatan_id" v-bind:value="data.kecamatan_id">	[{{data.kode_kecamatan}}] {{data.nama_kecamatan}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Desa / Kelurahan</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                    <input type="text" v-model="data.kode_des_kel" :required="true" id="kode_provinsi" class="form-control" placeholder="Kode Kecamatan">
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Nama Desa/Kelurahan</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="data.nama_des_kel"  :required="true" type="text" id="nama_provinsi" class="form-control" placeholder="Nama Kecamatan">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                        </form>

                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-green">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                            </div>
                            <form @submit.prevent="editData()">

                            <div class="modal-body">
                                <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Kabupaten</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <select @change="getDataKecamatan()" v-model="data.kabupaten_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                <option value="" :disabled="true">-- Pilih Kabupaten --</option>
                                                <option v-for="(data) in list_kabupaten" :key="data.kabupaten_id" v-bind:value="data.kabupaten_id">[{{data.kode_kabupaten}}] {{data.nama_kabupaten}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Kecamatan</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <select v-model="data.kecamatan_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                <option value="" :disabled="true">-- Pilih Kecamatan --</option>
                                                <option v-for="(data) in list_kecamatan" :key="data.kecamatan_id" v-bind:value="data.kecamatan_id">	[{{data.kode_kecamatan}}] {{data.nama_kecamatan}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Desa / Kelurahan</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                    <input type="text" v-model="data.kode_des_kel" :required="true" id="kode_provinsi" class="form-control" placeholder="Kode Kecamatan">
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Nama Desa/Kelurahan</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="data.nama_des_kel"  :required="true" type="text" id="nama_provinsi" class="form-control" placeholder="Nama Kecamatan">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


            <!-- ============================================================ MODAL ======================================================================== -->




    <!-- ============================================================ MULAI ======================================================================== -->
        </div>

    </div>

    </div>
    </section>



</div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_kecamatan/';
    const ADD_URL_KAB = URL_APP+'api/v1/planning_kabupaten/';
    const ADD_URL_KEC = URL_APP+'api/v1/planning_kecamatan/';
    export default {
        name: "planning_kabupaten",
        data() {
            return {
                data:{
                    kode_des_kel: '',
                    nama_des_kel: '',
                    kecamatan_id: '',
                    kabupaten_id: '',
                    des_kel_id: '',
                },
                kode_kecamatan: '',
                nama_kecamatan: '',
                kecamatan_id: '',
                kode_kabupaten: '',
                nama_kabupaten: '',
                kabupaten_id: '',

                list_kecamatan: [],
                list_kabupaten: [],
                list_data: [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'create_dari_kelurahan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                //   console.log(data_urusan);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData_dari_kelurahan', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((datanya) => {
                  this.list_data = datanya.data;
                  this.page_last = datanya.jml_data;
                //   console.log(datanya);
                })
            },
            
            editData: function(){
                fetch(ADD_URL+'updateData_dari_kelurahan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(koko){
                this.data = {
                    kode_des_kel: koko.kode_des_kel,
                    nama_des_kel: koko.nama_des_kel,
                    kecamatan_id: koko.kecamatan_id,
                    kabupaten_id: koko.kabupaten_id,
                    des_kel_id: koko.des_kel_id,
                };

                // console.log(koko);

                this.getDataKabupaten();
                this.getDataKecamatan();
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData_dari_kelurahan", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.data = {
                    kode_kecamatan: '',
                    nama_kecamatan: '',
                    kecamatan_id: '',
                    kabupaten_id: '',
                };
                this.list_kecamatan = [];
                this.list_kabupaten = [];
            },

        // TAMBAHAN
            getDataKabupaten: function(){
                fetch(ADD_URL_KAB+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_kabupaten = data_urusan.data;
                  
                })
            },
            getDataKecamatan: function(){
                fetch(ADD_URL_KEC+'dari_kelurahan', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      kabupaten_id : this.data.kabupaten_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_kecamatan = res_data;
                    // console.log(res_data);
                })
            },
        // TAMBAHAN

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
              this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
